import * as React from 'react';
export default function SvgGaming() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 17.94l1.365-2.215a1 1 0 01.851-.475h1.565a1 1 0 01.853.478l1.344 2.198c.744 1.23 2.147 1.722 3.298.936a2.235 2.235 0 00.949-2.178l-.91-6.043a3.047 3.047 0 00-.58-1.396A3.244 3.244 0 0015 7.75H9.006a3.244 3.244 0 00-2.724 1.48c-.296.387-.505.859-.588 1.403l-.919 6.06c-.129.852.244 1.7.959 2.18 1.143.77 2.543.314 3.266-.934zM12 7.5V4.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12a.5.5 0 11-1 0 .5.5 0 011 0zM15.5 12a.5.5 0 11-1 0 .5.5 0 011 0z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}